import PageMetaContainer from './page_meta_container';

const PageMeta = PageMetaContainer;

export default PageMeta;
